import EventEmitter from 'events'
const imagesLoaded = require('imagesloaded')

export default class Loading extends EventEmitter {
  constructor(_query) {
    super()
    this.query = _query
    // Preload images
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    })
  }
  init() {
    const preloadImages = () => {
      return new Promise(resolve => {
        imagesLoaded(
          document.querySelectorAll(this.query),
          { background: false },
          () => {
            resolve('loaded')
          }
        )
      })
    }
    // And then..
    preloadImages().then(value => {
      this.emit('loaded')
    })
  }
}
